export default "__VITE_ASSET__xE8b3S0Y__"